import type { BrandIconProps } from './brandIconTypes';

export default function UnityIcon({ className, ...props }: BrandIconProps) {
  return (
    <svg
      viewBox="0 0 44 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M23.9234 8.94556L31.7914 13.5141C32.0745 13.6745 32.0847 14.1194 31.7914 14.2798L22.4423 19.7123C22.1595 19.8779 21.8252 19.8676 21.5629 19.7123L12.2137 14.2798C11.9257 14.1246 11.9205 13.6693 12.2137 13.5141L20.0767 8.94556V0L0 11.6618V34.9856L7.69847 30.5153V21.3783C7.69333 21.0524 8.07386 20.8195 8.35673 20.9954L17.706 26.428C17.9888 26.5935 18.1482 26.8885 18.1482 27.1937V38.0537C18.1534 38.3797 17.7728 38.6125 17.49 38.4366L9.62179 33.8678L1.92333 38.3381L22 50L42.0766 38.3381L34.3784 33.8678L26.5101 38.4366C26.2324 38.6072 25.8415 38.3847 25.8518 38.0537V27.1937C25.8518 26.8678 26.0318 26.578 26.2941 26.428L35.6435 20.9954C35.921 20.8247 36.312 21.042 36.3015 21.3783V30.5153L44 34.9856V11.6618L23.9234 0V8.94556Z"
        fill="currentColor"
      />
    </svg>
  );
}
